import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getPendingRequest } from './firebase';
import { STATUS_IDLE, STATUS_FETCHING, STATUS_ERROR, STATUS_READY } from './constants';

export const fetchPendingRequests = createAsyncThunk(
  'fetchPendingRequests',
  async (params) => await getPendingRequest(params)
);

const employeeSlice = createSlice({
  name: 'pendingRequest',
  initialState: {
    status: STATUS_IDLE,
    data: null,
  },
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(fetchPendingRequests.pending, (state, action) => {
        state.status = STATUS_FETCHING;
      })
      .addCase(fetchPendingRequests.fulfilled, (state, action) => {
        state.status = STATUS_READY;
        state.data = action.payload;
      })
      .addCase(fetchPendingRequests.rejected, (state, action) => {
        state.status = STATUS_ERROR;
        state.error = action.error.message;
      });
  },
});

export default employeeSlice.reducer;
